<template>
  <div class="header" v-if="isHome">
    <div class="l-head">
      <h1 class="l-logo-img">
        <!-- <img class="l-logo" src="../../../static/logo.png" alt="logo" /> -->
        <img
          style="width: 40px; margin-top: -4px; cursor: pointer"
          src="../../../static/logo-2.png"
          alt="logo"
        />
      </h1>
      <div class="l-head-list">
        <div class="l-h-l-view">
          <ul class="l-h-l-ul">
            <li
              class="l-h-l-li"
              :class="$route.name === 'Home' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/home`)"
            >
              播聘集团
            </li>
            <li
              class="l-h-l-li"
              :class="$route.name === 'DSDownload' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/ds/download`)"
            >
              滴熵招聘
            </li>
            <li class="l-h-l-li" @click="navgoTo(`/enterprise-home`)">
              合约服务
            </li>
            <li
              :class="
                $route.name === 'EnterpriseUserDesktop' ? 'l-h-l-li-active' : ''
              "
              class="l-h-l-li"
              @click="navgoTo(`/enterprise-user-desktop`)"
            >
              企业招聘
            </li>
            <li
              :class="$route.name === 'JobEmployment' ? 'l-h-l-li-active' : ''"
              class="l-h-l-li"
              @click="navgoTo(`/job/job`)"
            >
              求职就业
            </li>
            <li class="l-h-l-li" @click="handleClick">播聘传媒</li>
            <li class="l-h-l-li" @click="navgoTo(`/company-relation`)">
              联系播聘
            </li>
          </ul>
        </div>
        <div>
          <!-- <button class="l-head-btn1" type="button">我要求职</button>
					<button class="l-head-btn" type="button">我要招聘</button> -->
          <!-- <a href="https://www.abopin.com/ep_manager" class="l-head-btn_1" >注册登录</a> -->
        </div>
      </div>
    </div>
  </div>

  <div class="header-1" v-else>
    <div class="l-head">
      <h1 class="l-logo-img" @click="navgoTo(`/home`)">
        <img class="l-logo" src="../../../static/l-logo.png" alt="logo" />
      </h1>
      <div class="l-head-list">
        <ul class="l-h-l-ul">
          <li class="l-h-l-li" @click="navgoTo(`/home`)">首页</li>
          <li class="l-h-l-li l-h-l-li-active-1" @click="navgoTo(navBar.path)">
            {{ navBar.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isHome: {
      type: [Boolean],
      default: !0
    }
  },
  data() {
    return {
      navBar: {
        title: "播聘新闻",
        path: "/show-news"
      }
    };
  },
  created() {
    this.route();
  },
  methods: {
    handleClick() {
      window.open("http://media.abopin.com", "_blank");
    },
    navgoTo(path) {
      this.$nav({ path: path }, this);
    },
    route() {
      let n = this.$route;
      if (n.name === `ShowHelp`) {
        this.navBar = {
          title: "帮助中心",
          path: "/show-help"
        };
      } else if (n.name === `ShowPrivacyPolicy`) {
        this.navBar = {
          title: "联系播聘",
          path: "/show-privacy-policy"
        };
      } else if (n.name === `CompanyGrow`) {
        this.navBar = {
          title: "公司成长",
          path: "/company-grow"
        };
      } else if (n.name === `CompanyHonor`) {
        this.navBar = {
          title: "公司荣誉",
          path: "/company-honor"
        };
      } else if (n.name === `RecruitmentSkills`) {
        this.navBar = {
          title: "招聘技巧",
          path: "/recruitment-skills"
        };
      } else if (n.name === `JobHuntingSkills`) {
        this.navBar = {
          title: "求职技巧",
          path: "/job-hunting-skills"
        };
      } else {
        this.navBar = {
          title: "播聘资讯",
          path: "/show-news"
        };
      }
    }
  },
  watch: {
    $route(n) {
      this.route();
    }
  }
};
</script>

<style scoped="scoped">
@import url("./navbar.css");
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue